"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSeason = exports.SeasonNames = void 0;
exports.SeasonNames = {
    PRE_SPAWN: 'pre_spawn',
    SPAWN: 'spawn',
    POST_SPAWN: 'post_spawn',
    SUMMER: 'summer',
    FALL: 'fall',
    WINTER: 'winter',
    ICE: 'ice',
};
function mockSeason(overrides = {}) {
    return {
        active: false,
        display_name: 'mock display_name',
        id: 1,
        name: exports.SeasonNames.SUMMER,
        ...overrides,
    };
}
exports.mockSeason = mockSeason;
